import App from './App';
import ShortcodeClaim from './components/shortcodes/claim';
import ShortcodeFavorites from './components/shortcodes/favorites';
import Template from './components/global/template';

if (window.bvm) {
  window.bvm.frontReady = false;
  window.bvm.app = new App();
  document.dispatchEvent(new CustomEvent('bvm_app_ready'));
}

class Main {
  constructor() {
    this.init();
    this.config();
  }

  init() {
    this.components = {
      blocks: {
      },
      global: {
        template: new Template(),
      },
      shortcodes: {
        claim: new ShortcodeClaim(),
        favorites: new ShortcodeFavorites(),
      },
    };
  }

  config() {
    if (! window.bvm) {
      return;
    }

    jQuery.ajax({
      url: window.bvm.ajax,
      method: 'POST',
      data: {
        action: 'bvm_get_config',
      },
    })
    .done(response => {
      if (response.success) {
        for (const key in response.data) {
          if (Object.hasOwnProperty.call(response.data, key)) {
            window.bvm[key] = response.data[key];
          }
        }

        jQuery(document).trigger('bvm_config_ready', window.bvm);
      }
    })
    .fail(error => {
      console.error(error);
    });
  }
}

jQuery(document).ready(() => {
  setTimeout(function() {
    jQuery(document).trigger(`bvm_front_ready`, new Main());

    if (window.bvm) {
      window.bvm.frontReady = true;
    }
  }, 150)
});

